export default __webpack_public_path__ + "static/media/research6.7850e021.jpg";